module.exports = __webpack_public_path__ + "media/chat.8e460c89.mp3";